import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import { Paragraph, Subheading, tokens } from '@treams/treams-ui';

import BareLayout from '../../../../../../src/packages/kakapo-ui-application/layouts/BareLayout';
import PublicForm from '../../components/authentication/PublicForm';

export default function UnregisteredAccount() {
	const { t } = useTranslation();

	return (
		<BareLayout>
			<Formik initialValues={{}} onSubmit={() => {}}>
				{() => (
					<PublicForm>
						<Box textAlign="center">
							<Subheading mb={`${tokens.gap.group}px`}>
								{t('common.unregisteredAccount.success.subtitle')}
							</Subheading>
							<Paragraph mb={3}>{t('common.unregisteredAccount.success.title')}</Paragraph>
							<Paragraph>{t('common.unregisteredAccount.success.message')}</Paragraph>
						</Box>
					</PublicForm>
				)}
			</Formik>
		</BareLayout>
	);
}
